import { dateLocales } from '@/components/language-switcher'
import { format } from 'date-fns'
import {
  isArray,
  isNull,
  isObject,
  isString,
  isUndefined,
  mapKeys,
  mapValues,
  snakeCase,
} from 'lodash-es'

const frEUR = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
})

export const formatPrice = (price: number | undefined) => {
  if (price === undefined) {
    return null
  }

  return frEUR.format(price)
}

export const formatDate = (
  date: string | Date,
  locale: string = 'en',
  toFormat: string = 'HH:mm, dd MMM yyyy'
) => {
  return format(date, toFormat, { locale: dateLocales[locale] })
}

export const removeNullParams = (
  params: Record<string, any>
): URLSearchParams => {
  if (!params) {
    return new URLSearchParams()
  }

  Object.keys(params).forEach((key) => {
    const value = (params as any)[key]
    if (
      isNull(value) ||
      isUndefined(value) ||
      (isString(value) && value.length === 0)
    ) {
      delete (params as any)[key]
    }
  })

  return new URLSearchParams(params)
}

export function snakeCaseObject(obj: Record<string, any>): any {
  if (isArray(obj)) {
    return obj.map(snakeCaseObject)
  }

  if (isObject(obj)) {
    return mapKeys(mapValues(obj, snakeCaseObject), (value, key) =>
      snakeCase(key)
    )
  }

  return obj
}
